<template>
  <DashboardCard :border="false" :firstContent="true">
    <template #content>
      <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h4 class="mb-0 font-20px">{{ $t("widgets.boosterCcs.title") }}</h4>
        <router-link
          v-if="hasMore"
          :to="{ name: 'boosterCcsHistory' }"
          class="see-more fw-bold text-uppercase"
        >
          {{ $t("widgets.boosterCcs.seeMore") }}
        </router-link>
      </div>
    </template>
    <template #table>
      <div class="widget-body" v-if="latest">
        <BoosterCcsPeriodBlock :period="latest" />
      </div>
      <p v-else class="widget-body mb-0 text-muted">
        {{ $t("widgets.boosterCcs.empty") }}
      </p>
    </template>
  </DashboardCard>
</template>

<script setup>
import { computed, defineProps } from "vue";
import DashboardCard from "../User/Wholesaler/DashboardCard.vue";
import BoosterCcsPeriodBlock from "./BoosterCcsPeriodBlock.vue";

const props = defineProps({
  data: { type: Object, required: true },
});

const latest = computed(() => props.data?.latest ?? null);
const hasMore = computed(() => Boolean(props.data?.has_more));
</script>

<style scoped lang="scss">
.font-20px {
  font-size: 20px;
}

.see-more {
  color: #e60012;
  text-decoration: none;
  font-size: 13px;
  letter-spacing: 0.02em;

  &:hover {
    text-decoration: underline;
  }
}

.widget-body {
  padding-top: 1rem;
}
</style>
